import React from 'react';
import { Palette } from 'lucide-react';
import DimensionTaskView from './DimensionTaskView';

const Creative = ({ user }) => {
  return (
    <DimensionTaskView
      user={user}
      dimension="creative"
      title="Creative"
      icon={Palette}
      color="#E91E63"
    />
  );
};

export default Creative;
